/* Lightweight storefront renderer for the daily Google reviews cache. */
(function () {
  var configScript = document.currentScript;
  var targetId = configScript && configScript.dataset.target;
  var root = targetId ? document.getElementById(targetId) : null;

  if (!root || root.dataset.wgrBootScheduled === 'true') return;
  root.dataset.wgrBootScheduled = 'true';

  function bootReviews() {
    if (root.dataset.wgrBooted === 'true') return;
    root.dataset.wgrBooted = 'true';

    var data = window.WillowGoogleReviewsData;
    var cardsTarget = root.querySelector('[data-wgr-cards]');
    var cardTemplate = root.querySelector('[data-wgr-card-template]');

    if (!data || !cardsTarget || !cardTemplate || !Array.isArray(data.reviews) || !data.reviews.length) {
      root.dataset.wgrCacheState = 'missing';
      return;
    }

    var reviews = data.reviews.slice(0, 24).filter(function (review) {
      return review && review.name && review.text;
    });
    var LOOP_CLONES = 3;
    var renderedReviewCount = reviews.length;
    var loopCloneCount = Math.min(LOOP_CLONES, renderedReviewCount);
    var loopFrame;
    var scrollSettleTimer;
    var rotationTimer;
    var isScrolling = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var dragState = {
      active: false,
      moved: false,
      pointerId: null,
      startX: 0,
      startScroll: 0
    };
    var suppressClick = false;

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element && value !== undefined && value !== null && value !== '') {
        element.textContent = String(value);
      }
    }

    function syncHeader() {
      ['trustpilot', 'judgeme'].forEach(function (platform) {
        var aggregate = data.platforms && data.platforms[platform];
        var score = root.querySelector('[data-wgr-' + platform + '-score]');
        if (!score || !aggregate || !aggregate.rating || !aggregate.count) return;
        score.textContent = String(aggregate.rating) + ' · ' + String(aggregate.count) + ' reviews';
        score.hidden = false;
      });
      setText('[data-wgr-rating]', data.rating);
      setText('[data-wgr-count]', data.count);
      setText('[data-wgr-ai-count]', data.count);

      var googlePlatform = root.querySelector('[data-wgr-google-platform]');
      if (googlePlatform && data.googleUrl) googlePlatform.href = data.googleUrl;

      var googleScore = root.querySelector('[data-wgr-google-score]');
      if (googleScore) {
        var scoreParts = [];
        if (data.rating) scoreParts.push(String(data.rating));
        if (data.count) scoreParts.push(String(data.count) + ' reviews');
        if (scoreParts.length) {
          googleScore.textContent = scoreParts.join(' · ');
          googleScore.hidden = false;
        }
      }

      var panel = root.querySelector('[data-wgr-ai-summary]');
      var list = root.querySelector('[data-wgr-ai-points]');
      var points = Array.isArray(data.summary) ? data.summary.filter(Boolean).slice(0, 3) : [];

      if (!panel || !list || !points.length) return;
      list.replaceChildren();
      points.forEach(function (point) {
        var item = document.createElement('li');
        item.textContent = String(point).replace(/[;,.]+$/, '');
        list.appendChild(item);
      });
      panel.hidden = false;
    }

    function createReviewCard(review, index, clonePosition) {
      var card = cardTemplate.content.cloneNode(true);
      var article = card.querySelector('.wgr-card');
      article.dataset.wgrIndex = String(index);

      if (clonePosition) {
        article.dataset.wgrClone = clonePosition;
        article.setAttribute('aria-hidden', 'true');
      } else {
        article.dataset.wgrReal = 'true';
      }

      card.querySelector('[data-wgr-review-text]').textContent = review.text;
      card.querySelector('[data-wgr-author]').textContent = review.name;
      card.querySelector('[data-wgr-meta]').textContent = review.date
        ? 'Verified Google review · ' + review.date
        : 'Verified Google review';

      var originalLink = card.querySelector('[data-wgr-review-link]');
      if (originalLink) originalLink.href = review.url || data.googleUrl || originalLink.href;

      var media = card.querySelector('[data-wgr-review-media]');
      var photos = Array.isArray(review.photos) ? review.photos.filter(Boolean).slice(0, 2) : [];

      if (media && photos.length) {
        media.hidden = false;
        article.classList.add('has-review-media');

        photos.forEach(function (photoUrl) {
          var photoLink = document.createElement('a');
          photoLink.className = 'wgr-review-photo-link';
          photoLink.href = review.url || data.googleUrl || '#';
          photoLink.target = '_blank';
          photoLink.rel = 'noopener';
          photoLink.setAttribute('aria-label', 'Open photo in the original Google review');

          var image = document.createElement('img');
          image.className = 'wgr-review-photo';
          image.src = photoUrl;
          image.alt = 'Customer photo from ' + review.name;
          image.loading = 'lazy';
          image.decoding = 'async';

          photoLink.appendChild(image);
          media.appendChild(photoLink);
        });
      }

      if (clonePosition) {
        article.querySelectorAll('a, button').forEach(function (interactive) {
          interactive.tabIndex = -1;
        });
      }

      return card;
    }

    function cardStep() {
      var card = cardsTarget.querySelector('.wgr-card');
      if (!card) return 0;
      var styles = window.getComputedStyle(cardsTarget);
      return card.getBoundingClientRect().width + (parseFloat(styles.gap) || 0);
    }

    function carouselPeekOffset() {
      if (window.matchMedia('(max-width: 749px)').matches) return 0;
      var card = cardsTarget.querySelector('.wgr-card');
      if (!card) return 0;
      var styles = window.getComputedStyle(cardsTarget);
      var gap = parseFloat(styles.gap) || 0;
      var visibleCards = window.matchMedia('(max-width: 989px)').matches ? 2 : 3;
      var visibleWidth = card.getBoundingClientRect().width * visibleCards + gap * (visibleCards - 1);
      return Math.max(0, (cardsTarget.clientWidth - visibleWidth) / 2);
    }

    function loopMetrics() {
      var step = cardStep();
      if (!step || !renderedReviewCount || renderedReviewCount <= 3) return null;
      var start = loopCloneCount * step - carouselPeekOffset();
      return {
        step: step,
        start: start,
        width: renderedReviewCount * step,
        end: start + renderedReviewCount * step
      };
    }

    function renderCards() {
      var fragment = document.createDocumentFragment();

      if (renderedReviewCount > 3) {
        reviews.slice(-loopCloneCount).forEach(function (review, cloneIndex) {
          fragment.appendChild(createReviewCard(
            review,
            renderedReviewCount - loopCloneCount + cloneIndex,
            'before'
          ));
        });
      }

      reviews.forEach(function (review, index) {
        fragment.appendChild(createReviewCard(review, index, ''));
      });

      if (renderedReviewCount > 3) {
        reviews.slice(0, loopCloneCount).forEach(function (review, index) {
          fragment.appendChild(createReviewCard(review, index, 'after'));
        });
      }

      cardsTarget.classList.add('is-loop-resetting');
      cardsTarget.replaceChildren(fragment);

      var metrics = loopMetrics();
      if (metrics) cardsTarget.scrollLeft = metrics.start;

      requestAnimationFrame(function () {
        cardsTarget.classList.remove('is-loop-resetting');
      });

      var controls = root.querySelector('[data-wgr-controls]');
      if (controls) controls.hidden = renderedReviewCount <= 3;
    }

    function normalizeLoopPosition() {
      var metrics = loopMetrics();
      if (!metrics) return;
      var current = cardsTarget.scrollLeft;
      var target = null;

      if (current <= 1) target = current + metrics.width;
      else if (current >= metrics.end - 1) target = current - metrics.width;
      if (target === null) return;

      cardsTarget.classList.add('is-loop-resetting');
      cardsTarget.scrollLeft = target;
      if (dragState.active) dragState.startScroll += target - current;
      requestAnimationFrame(function () {
        cardsTarget.classList.remove('is-loop-resetting');
      });
    }

    function scheduleLoopCheck() {
      if (loopFrame) return;
      loopFrame = requestAnimationFrame(function () {
        loopFrame = null;
        normalizeLoopPosition();
      });
    }

    function handleCardsScroll() {
      isScrolling = true;
      scheduleLoopCheck();
      window.clearTimeout(scrollSettleTimer);
      scrollSettleTimer = window.setTimeout(function () {
        isScrolling = false;
        normalizeLoopPosition();
      }, 180);
    }

    function scrollReviews(direction) {
      if (renderedReviewCount <= 3 || document.hidden) return;
      var step = cardStep();
      if (!step) return;
      normalizeLoopPosition();
      cardsTarget.scrollBy({
        left: direction * step,
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    function stopRotation() {
      if (!rotationTimer) return;
      window.clearInterval(rotationTimer);
      rotationTimer = null;
    }

    function startRotation() {
      if (rotationTimer || renderedReviewCount <= 3 || reducedMotion.matches || document.hidden) return;
      rotationTimer = window.setInterval(function () { scrollReviews(1); }, 7000);
    }

    function beginMouseDrag(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button')) return;
      dragState.active = true;
      dragState.moved = false;
      dragState.pointerId = event.pointerId;
      dragState.startX = event.clientX;
      dragState.startScroll = cardsTarget.scrollLeft;
      stopRotation();
      if (cardsTarget.setPointerCapture) cardsTarget.setPointerCapture(event.pointerId);
    }

    function moveMouseDrag(event) {
      if (!dragState.active || event.pointerId !== dragState.pointerId) return;
      var distance = event.clientX - dragState.startX;
      if (!dragState.moved && Math.abs(distance) < 6) return;

      if (!dragState.moved) {
        dragState.moved = true;
        cardsTarget.classList.add('is-dragging');
        root.dataset.wgrDragging = 'true';
        var selection = window.getSelection ? window.getSelection() : null;
        if (selection) selection.removeAllRanges();
      }

      event.preventDefault();
      cardsTarget.scrollLeft = dragState.startScroll - distance;
    }

    function endMouseDrag(event) {
      if (!dragState.active || event.pointerId !== dragState.pointerId) return;
      var didMove = dragState.moved;
      dragState.active = false;
      dragState.moved = false;

      if (cardsTarget.releasePointerCapture && cardsTarget.hasPointerCapture(event.pointerId)) {
        cardsTarget.releasePointerCapture(event.pointerId);
      }

      dragState.pointerId = null;
      cardsTarget.classList.remove('is-dragging');
      root.dataset.wgrDragging = 'false';

      if (didMove) {
        suppressClick = true;
        var step = cardStep();
        if (step) {
          cardsTarget.scrollTo({
            left: Math.max(0, Math.min(
              Math.round(cardsTarget.scrollLeft / step) * step,
              cardsTarget.scrollWidth - cardsTarget.clientWidth
            )),
            behavior: reducedMotion.matches ? 'auto' : 'smooth'
          });
        }
        window.setTimeout(function () { suppressClick = false; }, 180);
      }

      startRotation();
    }

    syncHeader();
    renderCards();
    root.classList.add('is-ready');
    root.dataset.wgrLive = 'cached';
    root.dataset.wgrCacheState = 'ready';
    root.dataset.wgrReviewCount = String(renderedReviewCount);
    root.dataset.wgrCacheUpdatedAt = data.updatedAt || '';

    var previousButton = root.querySelector('[data-wgr-prev]');
    var nextButton = root.querySelector('[data-wgr-next]');
    if (previousButton) previousButton.addEventListener('click', function () { scrollReviews(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { scrollReviews(1); });

    cardsTarget.addEventListener('mouseenter', stopRotation);
    cardsTarget.addEventListener('mouseleave', startRotation);
    cardsTarget.addEventListener('pointerdown', beginMouseDrag);
    cardsTarget.addEventListener('pointermove', moveMouseDrag);
    cardsTarget.addEventListener('pointerup', endMouseDrag);
    cardsTarget.addEventListener('pointercancel', endMouseDrag);
    cardsTarget.addEventListener('scroll', handleCardsScroll, { passive: true });
    cardsTarget.addEventListener('dragstart', function (event) { event.preventDefault(); });
    cardsTarget.addEventListener('click', function (event) {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopRotation();
      else startRotation();
    });

    var handleReducedMotionChange = function () {
      if (reducedMotion.matches) stopRotation();
      else startRotation();
    };
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', handleReducedMotionChange);
    else if (reducedMotion.addListener) reducedMotion.addListener(handleReducedMotionChange);
    startRotation();
  }

  if ('IntersectionObserver' in window) {
    var visibilityObserver = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      visibilityObserver.disconnect();
      bootReviews();
    }, { rootMargin: '1400px 0px' });
    visibilityObserver.observe(root);
  } else {
    window.addEventListener('load', function () {
      window.setTimeout(bootReviews, 400);
    }, { once: true });
  }
})();
